(function () {
	const sectionTabs = () => {
		const tabsSections = document.querySelectorAll(".testimonials");
		tabsSections.forEach((tabSection) => {
			const tabs = tabSection.querySelectorAll("[data-tab-target]");
			const tabContents = tabSection.querySelectorAll("[data-tab-content]");

			let maxContentHeight = 0;

			tabContents.forEach((tabContent) => {
				const originalDisplay = tabContent.style.display;
				tabContent.style.display = "block";
				let tabItemInfoBlock = tabContent.querySelector(
					".testimonials__item-block"
				);

				if (tabItemInfoBlock.clientHeight > maxContentHeight) {
					maxContentHeight = tabItemInfoBlock.clientHeight;
				}

				tabContent.style.display = originalDisplay;
			});

			tabContents.forEach(function (tabContent) {
				let tabItemInfoBlock = tabContent.querySelector(
					".testimonials__item-block"
				);
				tabItemInfoBlock.style.minHeight = maxContentHeight + "px";
			});

			const activateTab = (tab) => {
				if (tab.classList.contains("active")) return;
				const targets = tabSection.querySelectorAll(
					`[data-tab-content="${tab.dataset.tabTarget}"]`
				);
				tabContents.forEach((tabContent) => {
					tabContent.classList.remove("active");
				});
				tabs.forEach((tab) => {
					tab.classList.remove("active");
				});
				tab.classList.add("active");
				targets.forEach((target) => {
					target.classList.add("active");
				});
			};

			tabs.forEach((tab) => {
				tab.addEventListener("click", () => {
					activateTab(tab);
					// Bring the clicked tab into view when the list scrolls (mobile).
					// scrollTo on the list only, so ancestors (overflow: hidden) don't shift.
					const tabsList = tabSection.querySelector(".testimonials-tabs-list");
					if (tabsList) {
						tabsList.scrollTo({
							left:
								tabsList.scrollLeft +
								tab.getBoundingClientRect().left -
								tabsList.getBoundingClientRect().left,
							behavior: "smooth",
						});
					}
				});
			});

			// On mobile the tab list scrolls horizontally; switch the content to
			// the tab that settles at the start edge once scrolling stops.
			const tabsList = tabSection.querySelector(".testimonials-tabs-list");
			if (tabsList) {
				let scrollTimer;
				tabsList.addEventListener("scroll", () => {
					clearTimeout(scrollTimer);
					scrollTimer = setTimeout(() => {
						if (tabsList.scrollWidth <= tabsList.clientWidth + 1) return;
						const atEnd =
							tabsList.scrollLeft + tabsList.clientWidth >=
							tabsList.scrollWidth - 1;
						if (atEnd) {
							activateTab(tabs[tabs.length - 1]);
							return;
						}
						const listLeft = tabsList.getBoundingClientRect().left;
						let closest = tabs[0];
						let minDistance = Infinity;
						tabs.forEach((tab) => {
							const distance = Math.abs(
								tab.getBoundingClientRect().left - listLeft
							);
							if (distance < minDistance) {
								minDistance = distance;
								closest = tab;
							}
						});
						activateTab(closest);
					}, 120);
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		sectionTabs();
		document.addEventListener("shopify:section:load", function () {
			sectionTabs();
		});
	});
})();
